import { loadAmplitude } from '../services/amplitude.js';
import { logger } from '../utils/logger.js';

// Garde anti-doublon : une seule émission par page load
let alreadyTracked = false;

/**
 * Détecte une page 404 via plusieurs signaux combinés (OR) :
 * 1. Présence d'une section avec la classe `._404_section` (Webflow)
 * 2. Le `<title>` contient "404" ou "page non trouvée"
 * 3. Le `<link rel="canonical">` pointe vers une URL contenant `/404`
 *
 * Un seul signal suffit pour considérer que c'est une 404.
 */
export function isNotFoundPage(): boolean {
  // Signal 1 : classe CSS Webflow
  if (document.querySelector('._404_section')) return true;

  // Signal 2 : title explicite
  const title = document.title.toLowerCase();
  if (title.includes('404') || title.includes('page non trouvée')) return true;

  // Signal 3 : canonical vers /404
  const canonical = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (canonical && canonical.href.includes('/404')) return true;

  return false;
}

/**
 * Sur une page 404, envoie un event Amplitude `404 detected` avec
 * les propriétés de contexte (URL, referrer, user_agent, etc.).
 *
 * - No-op si pas sur une page 404
 * - Idempotent : ne track qu'une seule fois par page load
 * - Attend que le SDK Amplitude soit chargé (via loadAmplitude) avant d'émettre
 */
export function handleNotFoundPage(): void {
  if (alreadyTracked) return;
  if (!isNotFoundPage()) return;

  alreadyTracked = true;
  logger.info('Page 404 détectée:', window.location.pathname);

  loadAmplitude(() => {
    if (!window.amplitude) {
      logger.warn('Amplitude non chargé, event 404 non envoyé');
      return;
    }

    window.amplitude.track('404 detected', {
      page_url: window.location.href,
      page_path: window.location.pathname,
      referrer: document.referrer || '(direct)',
      search_query: window.location.search,
      user_agent: navigator.userAgent,
      timestamp: new Date().toISOString(),
    });

    logger.info('Event Amplitude "404 detected" envoyé');
  });
}
